var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    staticClass: "feature-section mt-4"
  }, [_c('b-row', _vm._l(_vm.features, function (feature, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "feature-item"
    }, [_c('img', {
      staticClass: "feature-image",
      attrs: {
        "src": feature.image,
        "alt": feature.title
      }
    }), _c('div', {
      staticClass: "feature-text"
    }, [_c('h3', {
      staticClass: "feature-title"
    }, [_vm._v(_vm._s(_vm.$t(feature.title)))]), _c('p', {
      staticClass: "feature-description"
    }, [_vm._v(_vm._s(_vm.$t(feature.description)))])])])]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }